export default {
    title: '0 questionnaire | 1 questionnaire | {count} questionnaires',
    detailedBtn: 'Résultats détaillés',
    aggregatedBtn: 'Résultats agrégés',
	printBtn: 'Imprimer',
    exportUrl: '/api/projects/{projectToken}/survey-campaign/{reference}/export/questions-responses/{type}',
    surveyCampaignGraphs: {
        title: 'Constitution de la base de répondants'
    },
    surveyCampaignAnswersReportDetail: {
        title: 'Restitution graphique des réponses aux questions fermées'
    }
};
